import React, { useState } from "react";
import profile from "../../assets/profile.svg";
import profile2 from "../../assets/profile2.svg";
import BuyCheckout from "../../components/BuyCheckout";

function Trading() {
  const [checkout, setCheckout] = useState(false);
  const [trade, setTrade] = useState(false);
  const [mode, setMode] = useState("buy");

  const [data, setData] = useState([
    {
      id: 1,
      username: "Cinamon 2356",
      image: profile,
      status: "offline",
      card: "Amazon card",
      payment: "Bank transfer",
      price: "$52,389 USD",
      discount: "20% discount",
      range: "$20-$500",
    },
    {
      id: 2,
      username: "Thechemdesigner",
      image: profile2,
      status: "online",
      card: "Amazon card",
      payment: "Bank transfer",
      price: "$20,609 USD",
      discount: "2% discount",
      range: "$300-$3000",
    },
    {
      id: 3,
      username: "Cinamon 2356",
      image: profile,
      status: "offline",
      card: "Amazon card",
      payment: "Bank transfer",
      price: "$52,389 USD",
      discount: "20% discount",
      range: "$900-$2000",
    },
  ]);

  const [selectedId, setSelectedId] = useState(null);

  const selectedData = data.find((item) => item.id === selectedId);

  const handleModeChange = (newMode) => {
    setMode(newMode);
  };

  const handleCheckout = (id) => {
    setSelectedId(id);
    setCheckout((prevState) => !prevState);
  };

  const handleTrade = () => {
    setTrade((prevState) => !prevState);
  };

  return (
    <div className="md:mt-[-80px] mt-[0] md:w-[70vw] w-[100vw]   md:mx-0 bg-[#FCFCF6] p-[20px] relative z-[5] ">
      {/* upper flex */}
      <div className=" md:mb-[101px] mb-[30px] text-xs md:text-xl ">
        <div className="">
          <h2 className=" font-medium text-[#FBC108DC]">Tyrion balance:</h2>
          <p className="font-bold "> 24,800 token</p>
        </div>
      </div>

      {/* bottom flex, flex col small screen */}
      <div className="flex flex-col-reverse md:flex-row md:justify-between md:mb-[21px] md:mt-[-50px] mx-[54px] md:ml-0 ">
        {/* upper left flex */}
        <div className="ml-[-60px] md:ml-[0]">
          <div className="md:mb-[81px] mb-[20px]">
            <button
              className={`border-[#FBC108DC] border-[1px] border-solid ml-[35px]  w-[83px] md:w-[158px] h-[27px] md:h-[56px]  rounded-[4px] md:rounded-lg text-xs md:text-base `}
              style={{
                backgroundColor: mode === "buy" ? "#FBC108DC" : "white",
                color: mode === "buy" ? "white" : "black",
              }}
              onClick={() => handleModeChange("buy")}
            >
              Buy
            </button>
            <button
              className={`border-[#FBC108DC] ml-[-5px] md:ml-[-10px] border-[1px] border-solid w-[83px] md:w-[158px] h-[27px] md:h-[56px] rounded-[4px] md:rounded-lg text-xs  md:text-base `}
              style={{
                backgroundColor: mode === "sell" ? "#FBC108DC" : "white",
                color: mode === "sell" ? "white" : "black",
              }}
              onClick={() => handleModeChange("sell")}
            >
              Sell
            </button>
          </div>
          <div className="flex mt-[50px] md:mt-[0] justify-between gap-[20px] md:gap-[70px] items-center text-[10px] md:text-base mb-[23px] md:mb-0 ">
            <div className="flex gap-[10px] items-center">
              <input type="radio" name="transaction" className="  " />
              <label htmlFor="">Gift card</label>
            </div>
            <div className="flex gap-[10px] items-center">
              <input type="radio" name="transaction" className="" />
              <label htmlFor="">Other assets</label>
            </div>
          </div>
        </div>
        {/* upper right flex */}
        <div className="flex flex-col mb-[39px] md:mb-0 justify-self-end  ml-[-50px] md:ml-[0] ">
          <div className="justify-self-end ">
            <h3 className="md:text-2xl text-xs mb-[20px] md:mb-[26px]">
              Conversion of Naira to Tyrion
            </h3>
          </div>

          <form
            action=""
            className="flex flex-col md:mb-[31px] mb-[17px] text-[10px] md:text-base "
          >
            <label htmlFor="" className="text-[#00000060]">
              Amount
            </label>
            <input
              type="number"
              placeholder="Enter amount (N) "
              className="md:pl-[12px] pl-[6px] py-[8px] md:py-[15px] w-full"
            />
          </form>
          <div className="flex flex-col">
            <p className="border-b border-[#FBC108DC] md:border-b-[3px] mb-[8px] md:mb-[15px] text-[10px] md:text-base ">
              Equivalent tyrion amount
            </p>
            <h6 className="font-bold md:text-xl text-sm self-end">
              24,800 token
            </h6>
          </div>
        </div>
      </div>
      {/* lower flex */}
      <div>
        {/* select card type- no content */}
        <div className=""></div>
        <h6 className="mb-[30px] mt-[50px] md:mt-0 ">Offers available</h6>

        {data.map((transaction) => (
          <div className="flex items-center justify-between mb-[30px] bg-[#ffffff] rounded-lg text-xs md:text-sm px-[10px] py-[20px] w-full ">
            <div className="flex flex-col md:w-[200px]   ">
              <div className="flex items-center">
                <img
                  src={transaction.image}
                  alt=""
                  className="rounded-full w-[25px] h-[25px] md:w-auto md:h-auto mr-[10px] "
                />
                <div className="">
                  <h4 className="text-[#00000070] ">{transaction.username}</h4>
                  <h6 className="text-xs md:text-lg">{transaction.card}</h6>
                </div>
              </div>
              {transaction.status === "offline" && (
                <p className="text-[#00000040] ">3 hours ago</p>
              )}

              {transaction.status === "online" && (
                <div className="flex items-center gap-[4px] ">
                  <div className="bg-[#FBC108DC] w-[8px] h-[8px] rounded-full"></div>
                  <p className="text-[#00000040] ">Online</p>
                </div>
              )}
            </div>
            <div className="w-[80px] md:w-[200px] ">
              <h4>{transaction.payment}</h4>
            </div>
            <div className="w-[72px] md:w-[200px] md:ml-[-100px] ">
              <h4 className="md:text-lg text-[10px] font-medium">
                {transaction.price}
              </h4>
              <h6 className="text-[#00000060]">{transaction.discount}</h6>
            </div>
            <div className="hidden md:block md:ml-[-100px]">
              <h6 className="text-[#0000005e] ">Range:</h6>
              <small className="font-bold">{transaction.range}</small>
            </div>
            <button
              className="md:w-[108px] w-[72px] h-[24px] md:h-[38px] bg-[#FBC108DC] rounded-sm md:rounded-lg text-white "
              key={transaction.id}
              onClick={() => handleCheckout(transaction.id)}
            >
              {mode === "buy" ? "Buy" : "Sell"} Card
            </button>
          </div>
        ))}
      </div>
      {checkout && (
        <div className=" ">
          <div
            className="absolute top-0 left-0 z-20 w-full h-full bg-black bg-opacity-70 "
            onClick={handleCheckout}
          ></div>
          <div className="absolute w-[90vw] md:w-auto top-[5%] md:left-[15%] z-30">
            <BuyCheckout
              mode={mode === "buy" ? "Buy" : "Sell"}
              range={selectedData.range}
              assets={selectedData.card}
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default Trading;
